import t, { useState as e, useMemo as n, Fragment as o } from "react";
import r from "prop-types";
import { Transition as i } from "react-transition-group";
import { css as a, cx as c } from "@leafygreen-ui/emotion";
import l from "@leafygreen-ui/portal";
import { usePopoverContext as s, usePopoverPortalContainer as u } from "@leafygreen-ui/leafygreen-provider";
import { useViewportSize as f, useMutationObserver as p, useObjectDependency as d, usePrevious as h, useIsomorphicLayoutEffect as g } from "@leafygreen-ui/hooks";
import { consoleOnce as m } from "@leafygreen-ui/lib";

function w(t, e) {
  var n = Object.keys(t);

  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    e && (o = o.filter(function (e) {
      return Object.getOwnPropertyDescriptor(t, e).enumerable;
    })), n.push.apply(n, o);
  }

  return n;
}

function v(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = null != arguments[e] ? arguments[e] : {};
    e % 2 ? w(Object(n), !0).forEach(function (e) {
      y(t, e, n[e]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : w(Object(n)).forEach(function (e) {
      Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
    });
  }

  return t;
}

function y(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}

function E() {
  return E = Object.assign || function (t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];

      for (var o in n) {
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
      }
    }

    return t;
  }, E.apply(this, arguments);
}

function b(t, e) {
  if (null == t) return {};

  var n,
      o,
      r = function (t, e) {
    if (null == t) return {};
    var n,
        o,
        r = {},
        i = Object.keys(t);

    for (o = 0; o < i.length; o++) {
      n = i[o], e.indexOf(n) >= 0 || (r[n] = t[n]);
    }

    return r;
  }(t, e);

  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);

    for (o = 0; o < i.length; o++) {
      n = i[o], e.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
    }
  }

  return r;
}

function P(t, e) {
  return e || (e = t.slice(0)), Object.freeze(Object.defineProperties(t, {
    raw: {
      value: Object.freeze(e)
    }
  }));
}

function j(t, e) {
  return function (t) {
    if (Array.isArray(t)) return t;
  }(t) || function (t, e) {
    var n = null == t ? null : "undefined" != typeof Symbol && t[Symbol.iterator] || t["@@iterator"];
    if (null == n) return;
    var o,
        r,
        i = [],
        a = !0,
        c = !1;

    try {
      for (n = n.call(t); !(a = (o = n.next()).done) && (i.push(o.value), !e || i.length !== e); a = !0) {
        ;
      }
    } catch (t) {
      c = !0, r = t;
    } finally {
      try {
        a || null == n.return || n.return();
      } finally {
        if (c) throw r;
      }
    }

    return i;
  }(t, e) || C(t, e) || function () {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function O(t) {
  return function (t) {
    if (Array.isArray(t)) return S(t);
  }(t) || function (t) {
    if ("undefined" != typeof Symbol && null != t[Symbol.iterator] || null != t["@@iterator"]) return Array.from(t);
  }(t) || C(t) || function () {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }();
}

function C(t, e) {
  if (t) {
    if ("string" == typeof t) return S(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? S(t, e) : void 0;
  }
}

function S(t, e) {
  (null == e || e > t.length) && (e = t.length);

  for (var n = 0, o = new Array(e); n < e; n++) {
    o[n] = t[n];
  }

  return o;
}

var x,
    D,
    H,
    R,
    V,
    T,
    F,
    M,
    B = {
  Top: "top",
  Bottom: "bottom",
  Left: "left",
  Right: "right",
  CenterVertical: "center-vertical",
  CenterHorizontal: "center-horizontal"
},
    L = {
  Start: "start",
  Middle: "middle",
  End: "end",
  Fit: "fit"
};

function z(t) {
  var e = t.useRelativePositioning,
      n = t.spacing,
      o = t.align,
      r = t.justify,
      i = t.referenceElViewportPos,
      a = void 0 === i ? N : i,
      c = t.referenceElDocumentPos,
      l = void 0 === c ? N : c,
      s = t.contentElViewportPos,
      u = void 0 === s ? N : s,
      f = t.contentElDocumentPos,
      p = void 0 === f ? N : f,
      d = t.scrollContainer,
      h = t.windowHeight,
      g = void 0 === h ? window.innerHeight : h,
      m = t.windowWidth,
      w = void 0 === m ? window.innerWidth : m,
      y = d ? d.offsetWidth : w,
      E = d ? d.offsetHeight : g,
      b = {
    windowWidth: y,
    windowHeight: E,
    referenceElViewportPos: a,
    contentElViewportPos: u,
    spacing: n
  },
      P = function (t, e) {
    var n = e.spacing,
        o = e.windowWidth,
        r = e.windowHeight,
        i = e.contentElViewportPos,
        a = e.referenceElViewportPos;
    return [t].concat(O(tt[t])).find(function (t) {
      return [B.Top, B.Bottom, B.CenterVertical].includes(t) ? _({
        top: J({
          align: t,
          contentElPos: i,
          referenceElPos: a,
          spacing: n
        }),
        windowHeight: r,
        contentHeight: i.height
      }) : !![B.Left, B.Right, B.CenterHorizontal].includes(t) && Q({
        left: K({
          align: t,
          contentElPos: i,
          referenceElPos: a,
          spacing: n
        }),
        windowWidth: o,
        contentWidth: i.width
      });
    }) || t;
  }(o, b),
      j = function (t, e, n) {
    var o,
        r,
        i = n.spacing,
        a = n.windowWidth,
        c = n.windowHeight,
        l = n.contentElViewportPos,
        s = n.referenceElViewportPos,
        u = [t].concat(O(et[t]));

    switch (e) {
      case B.Top:
      case B.Bottom:
      case B.CenterVertical:
        return null !== (o = u.find(function (t) {
          return Q({
            contentWidth: t === L.Fit ? s.width : l.width,
            windowWidth: a,
            left: K({
              contentElPos: l,
              referenceElPos: s,
              spacing: i,
              align: e,
              justify: t
            })
          });
        })) && void 0 !== o ? o : et[t][0];

      case B.Left:
      case B.Right:
      case B.CenterHorizontal:
        return null !== (r = u.find(function (t) {
          return _({
            contentHeight: t === L.Fit ? s.height : l.height,
            windowHeight: c,
            top: J({
              contentElPos: l,
              referenceElPos: s,
              spacing: i,
              align: e,
              justify: t
            })
          });
        })) && void 0 !== r ? r : et[t][0];
    }
  }(r, P, b),
      C = function (t) {
    var e,
        n,
        o = t.align,
        r = t.justify,
        i = U[o],
        a = null !== (e = i.x) && void 0 !== e ? e : Z[r],
        c = null !== (n = i.y) && void 0 !== n ? n : k[r];
    return "".concat(a, " ").concat(c);
  }({
    align: P,
    justify: j
  }),
      S = function (t, e) {
    var n = .8;

    switch (t) {
      case B.Top:
        return "translate3d(0, ".concat(e, "px, 0) scale(").concat(n, ")");

      case B.Bottom:
        return "translate3d(0, -".concat(e, "px, 0) scale(").concat(n, ")");

      case B.Left:
        return "translate3d(".concat(e, "px, 0, 0) scale(").concat(n, ")");

      case B.Right:
        return "translate3d(-".concat(e, "px, 0, 0) scale(").concat(n, ")");

      case B.CenterHorizontal:
      case B.CenterVertical:
        return "scale(".concat(n, ")");
    }
  }(P, n);

  return 0 === Math.floor(u.width) && r !== L.Fit ? {
    align: o,
    justify: r,
    positionCSS: {
      left: 0,
      top: 0,
      transform: S,
      transformOrigin: C
    }
  } : e ? {
    align: P,
    justify: j,
    positionCSS: v(v({}, q({
      align: P,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n
    })), {}, {
      transformOrigin: C,
      transform: S
    })
  } : {
    align: P,
    justify: j,
    positionCSS: v(v({}, G({
      align: P,
      justify: j,
      referenceElDocumentPos: l,
      contentElDocumentPos: p,
      spacing: n,
      windowHeight: E,
      windowWidth: y
    })), {}, {
      transformOrigin: C,
      transform: S
    })
  };
}

var N = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  height: 0,
  width: 0
},
    W = function W(t, e) {
  var n = t.getBoundingClientRect(),
      o = n.top,
      r = n.bottom,
      i = n.left,
      a = n.right,
      c = n.width;
  return {
    top: o,
    bottom: r,
    left: i,
    right: a,
    height: t.offsetHeight,
    width: e ? c : parseFloat(getComputedStyle(t).width)
  };
};

function A(t, e, n) {
  if (!t) return N;
  var o = W(t, n),
      r = o.top,
      i = o.bottom,
      a = o.left,
      c = o.right,
      l = o.height,
      s = o.width;

  if (e) {
    var u = e.scrollTop,
        f = e.scrollLeft,
        p = e.getBoundingClientRect();
    return {
      top: r + u - p.top,
      bottom: i + u - p.bottom,
      left: a + f - p.left,
      right: c + f - p.right,
      height: l,
      width: s
    };
  }

  var d = window,
      h = d.scrollX,
      g = d.scrollY;
  return {
    top: r + g,
    bottom: i + g,
    left: a + h,
    right: c + h,
    height: l,
    width: s
  };
}

function I(t, e, n) {
  if (!t) return N;
  var o = W(t, n),
      r = o.top,
      i = o.bottom,
      a = o.left,
      c = o.right,
      l = o.height,
      s = o.width;

  if (e) {
    var u = e.getBoundingClientRect();
    return {
      top: r - u.top,
      bottom: i - u.bottom,
      left: a - u.left,
      right: c - u.right,
      height: l,
      width: s
    };
  }

  return {
    top: r,
    bottom: i,
    left: a,
    right: c,
    height: l,
    width: s
  };
}

var k = (y(x = {}, L.Start, "top"), y(x, L.Middle, "center"), y(x, L.End, "bottom"), y(x, L.Fit, "center"), x),
    Z = (y(D = {}, L.Start, "left"), y(D, L.Middle, "center"), y(D, L.End, "right"), y(D, L.Fit, "center"), D),
    U = (y(H = {}, B.Left, {
  x: "right"
}), y(H, B.Right, {
  x: "left"
}), y(H, B.Top, {
  y: "bottom"
}), y(H, B.Bottom, {
  y: "top"
}), y(H, B.CenterHorizontal, {
  x: "center"
}), y(H, B.CenterVertical, {
  y: "center"
}), H);
var X = (y(R = {}, L.Start, {
  top: 0
}), y(R, L.End, {
  bottom: 0
}), y(R, L.Middle, function (t) {
  var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
  return {
    top: "".concat(n.height / 2 - e.height / 2, "px")
  };
}), y(R, L.Fit, {
  top: 0,
  bottom: 0
}), R),
    Y = (y(V = {}, L.Start, {
  left: 0
}), y(V, L.End, {
  right: 0
}), y(V, L.Middle, function (t) {
  var e = t.contentElDocumentPos,
      n = t.referenceElDocumentPos;
  return {
    left: "".concat(n.width / 2 - e.width / 2, "px")
  };
}), y(V, L.Fit, {
  left: 0,
  right: 0
}), V),
    $ = (y(T = {}, B.Top, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      bottom: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: Y
}), y(T, B.Bottom, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      top: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: Y
}), y(T, B.CenterVertical, {
  constant: function constant(t) {
    var e = t.referenceElDocumentPos;
    return {
      top: "calc(".concat(e.height / 2, "px - 50%)")
    };
  },
  justifyPositions: Y
}), y(T, B.Left, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      right: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: X
}), y(T, B.Right, {
  constant: function constant(t) {
    var e = t.spacing;
    return {
      left: "calc(100% + ".concat(e, "px)")
    };
  },
  justifyPositions: X
}), y(T, B.CenterHorizontal, {
  constant: function constant(t) {
    var e = t.referenceElDocumentPos;
    return {
      left: "calc(".concat(e.width / 2, "px - 50%)")
    };
  },
  justifyPositions: X
}), T);

function q(t) {
  var e,
      n = t.align,
      o = t.justify,
      r = t.referenceElDocumentPos,
      i = t.contentElDocumentPos,
      a = t.spacing,
      c = $[n],
      l = c.justifyPositions[o],
      s = {
    contentElDocumentPos: i,
    referenceElDocumentPos: r,
    spacing: a
  };
  return v(v({}, null === (e = c.constant) || void 0 === e ? void 0 : e.call(c, s)), "function" == typeof l ? l(s) : l);
}

function G(t) {
  var e = t.align,
      n = t.justify,
      o = t.referenceElDocumentPos,
      r = t.contentElDocumentPos,
      i = t.spacing,
      a = t.windowWidth,
      c = t.windowHeight,
      l = K({
    align: e,
    justify: n,
    referenceElPos: o,
    contentElPos: r,
    spacing: i
  }),
      s = "".concat(l, "px"),
      u = "".concat(J({
    align: e,
    justify: n,
    referenceElPos: o,
    contentElPos: r,
    spacing: i
  }), "px");
  return n !== L.Fit ? {
    left: s,
    top: u
  } : [B.Left, B.Right, B.CenterHorizontal].includes(e) ? {
    left: s,
    top: u,
    bottom: "".concat(c - o.bottom, "px")
  } : {
    left: s,
    top: u,
    right: "".concat(a - (l + o.width), "px")
  };
}

function J(t) {
  var e = t.align,
      n = t.justify,
      o = t.contentElPos,
      r = t.referenceElPos,
      i = t.spacing;

  switch (e) {
    case B.Left:
    case B.Right:
    case B.CenterHorizontal:
      switch (n) {
        case L.Start:
        case L.Fit:
          return r.top;

        case L.End:
          return r.top + r.height - o.height;

        default:
          return r.top - (o.height - r.height) / 2;
      }

    case B.CenterVertical:
      return r.top - (o.height - r.height) / 2;

    case B.Top:
      return r.top - o.height - i;

    case B.Bottom:
    default:
      return r.top + r.height + i;
  }
}

function K(t) {
  var e = t.align,
      n = t.justify,
      o = t.contentElPos,
      r = t.referenceElPos,
      i = t.spacing;

  switch (e) {
    case B.Top:
    case B.Bottom:
    case B.CenterVertical:
      switch (n) {
        case L.End:
          return r.left + r.width - o.width;

        case L.Middle:
          return r.left - (o.width - r.width) / 2;

        default:
          return r.left;
      }

    case B.Left:
      return r.left - o.width - i;

    case B.Right:
      return r.left + r.width + i;

    case B.CenterHorizontal:
    default:
      return r.left - (o.width - r.width) / 2;
  }
}

function Q(t) {
  var e = t.left,
      n = t.windowWidth,
      o = t.contentWidth;
  return e >= 0 && !(e + o > n);
}

function _(t) {
  var e = t.top,
      n = t.windowHeight,
      o = t.contentHeight;
  return e >= 0 && !(e + o > n);
}

var tt = (y(F = {}, B.Top, [B.Bottom]), y(F, B.Bottom, [B.Top]), y(F, B.Left, [B.Right]), y(F, B.Right, [B.Left]), y(F, B.CenterHorizontal, [B.Left, B.Right]), y(F, B.CenterVertical, [B.Top, B.Bottom]), F);
var et = (y(M = {}, L.Start, [L.End, L.Middle]), y(M, L.Middle, [L.End, L.Start]), y(M, L.End, [L.Start, L.Middle]), y(M, L.Fit, [L.Middle, L.Start, L.End]), M);
var nt,
    ot,
    rt,
    it,
    at = ["active", "spacing", "align", "justify", "adjustOnMutation", "children", "className", "popoverZIndex", "refEl", "usePortal", "portalClassName", "portalContainer", "scrollContainer"],
    ct = ["transform"],
    lt = a(nt || (nt = P(["\n  position: absolute;\n  transition: transform 150ms ease-in-out, opacity 150ms ease-in-out;\n  opacity: 0;\n"]))),
    st = {
  attributes: !0,
  characterData: !0,
  childList: !0,
  subtree: !0
};

function ut(r) {
  var w = r.active,
      v = void 0 !== w && w,
      O = r.spacing,
      C = void 0 === O ? 10 : O,
      S = r.align,
      x = void 0 === S ? B.Bottom : S,
      D = r.justify,
      H = void 0 === D ? L.Start : D,
      R = r.adjustOnMutation,
      V = void 0 !== R && R,
      T = r.children,
      F = r.className,
      M = r.popoverZIndex,
      N = r.refEl,
      W = r.usePortal,
      k = void 0 === W || W,
      Z = r.portalClassName,
      U = r.portalContainer,
      X = r.scrollContainer,
      Y = b(r, at),
      $ = j(e(null), 2),
      q = $[0],
      G = $[1],
      J = j(e(null), 2),
      K = J[0],
      Q = J[1],
      _ = j(e(0), 2),
      tt = _[0],
      et = _[1],
      nt = s().setIsPopoverOpen,
      ut = u(),
      ft = ut.portalContainer,
      pt = ut.scrollContainer;

  ft = U || ft, pt = X || pt, k && pt && (pt.contains(ft) || m.warn("To ensure correct positioning make sure that the portalContainer element is inside of the scrollContainer"));
  var dt = t.useRef(K);
  dt.current = K;
  var ht = null;
  if (N && N.current) ht = N.current;else if (q) {
    var gt = q.parentNode;
    gt && gt instanceof HTMLElement && (ht = gt);
  }
  var mt = f(),
      wt = V && v,
      vt = p(ht, st, Date.now, wt),
      yt = p(null == K ? void 0 : K.parentNode, st, Date.now, wt),
      Et = d(I(ht, pt, !0)),
      bt = d(I(null == K ? void 0 : K.parentNode, pt)),
      Pt = d(n(function () {
    return A(ht, pt, !0);
  }, [ht, pt, mt, vt, v, x, H, tt])),
      jt = d(n(function () {
    return A(K);
  }, [null == K ? void 0 : K.parentNode, mt, yt, v, x, H, tt])),
      Ot = h(H),
      Ct = h(x),
      St = Ot !== H && (H === L.Fit || Ot === L.Fit) || Ct !== x && H === L.Fit;
  g(function () {
    St && et(function (t) {
      return t + 1;
    });
  }, [St]);
  var xt = j(e(!1), 2),
      Dt = xt[0],
      Ht = xt[1];
  if (g(function () {
    return Ht(!0);
  }, []), !Dt) return null;
  var Rt,
      Vt = z({
    useRelativePositioning: !k,
    spacing: C,
    align: x,
    justify: H,
    referenceElViewportPos: Et,
    referenceElDocumentPos: Pt,
    contentElViewportPos: bt,
    contentElDocumentPos: jt,
    scrollContainer: pt
  }),
      Tt = Vt.align,
      Ft = Vt.justify,
      Mt = Vt.positionCSS,
      Bt = Mt.transform,
      Lt = b(Mt, ct),
      zt = a(ot || (ot = P(["\n    opacity: 1;\n    position: ", ";\n    pointer-events: initial;\n  "])), k ? "" : "absolute"),
      Nt = k ? l : o,
      Wt = k ? ft ? {
    container: ft
  } : {
    className: null != Z ? Z : void 0
  } : {};
  return Rt = null == T ? null : "function" == typeof T ? T({
    align: Tt,
    justify: Ft,
    referenceElPos: Pt
  }) : T, t.createElement(i, {
    nodeRef: dt,
    in: v,
    timeout: 150,
    mountOnEnter: !0,
    unmountOnExit: !0,
    appear: !0,
    onEntered: function onEntered() {
      return nt(!0);
    },
    onExit: function onExit() {
      return nt(!1);
    }
  }, function (e) {
    var n;
    return t.createElement(t.Fragment, null, t.createElement("div", {
      ref: G,
      className: a(rt || (rt = P(["\n              display: none;\n            "])))
    }), t.createElement(Nt, Wt, t.createElement("div", E({}, Y, {
      className: c(lt, a(Lt), (n = {}, y(n, a({
        transform: Bt
      }), "entering" === e || "exiting" === e), y(n, zt, "entered" === e), y(n, a(it || (it = P(["\n                    z-index: ", ";\n                  "])), M), "number" == typeof M), n), F)
    }), t.createElement("div", {
      ref: Q
    }, Rt))));
  });
}

ut.displayName = "Popover", ut.propTypes = {
  children: r.oneOfType([r.node, r.func]),
  active: r.bool,
  className: r.string,
  align: r.oneOf(Object.values(B)),
  justify: r.oneOf(Object.values(L)),
  refEl: r.shape({
    current: "undefined" != typeof window ? r.instanceOf(Element) : r.any
  }),
  usePortal: r.bool,
  portalClassName: r.string,
  spacing: r.number,
  adjustOnMutation: r.bool
};
export { B as Align, L as Justify, ut as default };